// PorterIQ Custom Table Cell Styles

export default {
  styleOverrides: {
    root: {
      backgroundColor: "transparent !important",
      padding: "12px 16px",
      borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    },
    head: {
      backgroundColor: "transparent !important",
      fontWeight: 600,
    },
  },
};
